import { PartnerForm } from "@/features/partner/components/PartnerForm";
import { JAPAN_NATIONALITY_ID } from "@/types/enum";

export const PartnerCreatePage = () => {
  return (
    <PartnerForm
      defaultValues={{
        laborBureauStatus: false,
        sendingOrganization: false,
        prefecture: "",
        city: "",
        address: "",
        location: "",
        nationalityId: JAPAN_NATIONALITY_ID,
      }}
    />
  );
};
